/*
customizations:
- added RERImmersiveReader component
*/
import React from 'react';
import { RERImmersiveReader } from 'rer-theme/components';

const HeaderEnd = ({ content }) => {
  return (
    <>
      <RERImmersiveReader />
    </>
  );
};
export default HeaderEnd;
